import { render, staticRenderFns } from "./tijianLimit.vue?vue&type=template&id=4da1ba38"
import script from "./tijianLimit.vue?vue&type=script&lang=js"
export * from "./tijianLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports